export default __webpack_public_path__ + "affinity-designer.dd35b7b4.png";